import { css } from '../../../common.styles';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'icon';

export interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string;
  target?: '_blank' | '_self' | '';
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  disabled?: boolean;
  variant?: ButtonVariant;
  hideIcon?: boolean;
  darkBackground?: boolean;
  iconPosition?: 'right' | 'left';
  customIcon?: React.ReactNode;
  fullWidth?: boolean;
  chevron?: boolean;
  inverse?: boolean;
  width?: string;
  order?: number;
  transparentBackground?: boolean;
  underline?: boolean;
  justify?: 'flex-start' | 'center';
  darkMode?: boolean;
}

export const BasicButtonStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  text-decoration: none;
  min-width: max-content;
`;

export const SecondaryButtonWithDisabledStyle = css<{ disabled?: boolean | undefined }>`
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
`;

export const CommonArrowStyle = css<{ active: boolean }>`
  justify-content: center;
  align-items: center;
  cursor: ${(p) => (p.active ? 'pointer' : 'unset')};
`;

export const preventDefault =
  <E extends React.MouseEvent>(onClick: (e: E) => any) =>
  (e: E) => {
    const result = onClick(e);
    e.preventDefault();
    e.stopPropagation();
    return result;
  };

export const navigateAfter =
  <E extends React.MouseEvent>(
    onClick: (e: E) => unknown,
    url: string | undefined,
    target: '_self' | '_blank' = '_self'
  ) =>
  async (e: E) => {
    if (url && target === '_blank') {
      window.open(url);
    }
    await onClick(e);
    if (url && target === '_self') {
      window.open(url, '_self');
    }
  };
